import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg, LOGO } from "@/lib/api";

export default function Login({ admin = false }) {
  const { login } = useAuth();
  const nav = useNavigate();
  const [dni, setDni] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [recovery, setRecovery] = useState(false);
  const [resetToken, setResetToken] = useState("");
  const [newPw, setNewPw] = useState("");

  const inp = "w-full border border-[#dcd5ce] bg-white px-4 py-3 text-sm outline-none focus:border-[#c5a059]";

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const data = await login(dni, password);
      if (admin && data.user.role !== "admin") {
        toast.error("Este acceso es exclusivo para la profesional");
        return;
      }
      nav(data.user.role === "admin" ? "/admin" : "/portal/inicio");
    } catch (err) { toast.error(errMsg(err)); } finally { setLoading(false); }
  };

  const pedirToken = async () => {
    try {
      const { data } = await api.post("/auth/forgot-password", { dni });
      setResetToken(data.reset_token);
      toast.success("Código generado. Definí tu nueva contraseña.");
    } catch (err) { toast.error(errMsg(err)); }
  };

  const resetear = async () => {
    try {
      await api.post("/auth/reset-password", { dni, token: resetToken, new_password: newPw });
      toast.success("Contraseña actualizada. Ya podés ingresar.");
      setRecovery(false); setResetToken(""); setNewPw("");
    } catch (err) { toast.error(errMsg(err)); }
  };

  return (
    <div data-testid={admin ? "admin-login-page" : "portal-login-page"} className="flex min-h-screen items-center justify-center bg-[#f9f8f6] px-6 py-16">
      <div className="w-full max-w-md">
        <Link to="/" className="mx-auto block w-24"><img src={LOGO} alt="Nilo" className="w-24 rounded-full" /></Link>
        <h1 className="mt-8 text-center text-4xl tracking-tight">{admin ? "Acceso Administrador" : "Portal Paciente"}</h1>
        <p className="mt-3 text-center text-sm text-[#5e5a56]">
          {admin ? "Ingreso exclusivo de la Lic. Daniela Roppel" : "Ingresá con tu número de DNI"}
        </p>

        {!recovery ? (
          <form onSubmit={submit} className="card-nilo mt-10 space-y-4 p-8">
            <input data-testid="login-dni" required placeholder={admin ? "Usuario" : "DNI"} className={inp} value={dni} onChange={(e) => setDni(e.target.value)} />
            <input data-testid="login-password" required type="password" placeholder="Contraseña" className={inp} value={password} onChange={(e) => setPassword(e.target.value)} />
            <button data-testid="login-submit" disabled={loading} className="btn-gold w-full rounded-full px-8 py-3.5 text-xs font-semibold uppercase tracking-[0.18em]">
              {loading ? "Ingresando..." : "Ingresar"}
            </button>
            {!admin && (
              <button type="button" data-testid="login-forgot" onClick={() => setRecovery(true)} className="w-full text-xs text-[#8b7355] underline">
                Olvidé mi contraseña
              </button>
            )}
          </form>
        ) : (
          <div className="card-nilo mt-10 space-y-4 p-8" data-testid="recovery-box">
            <p className="label-xs">Recuperar contraseña</p>
            <input data-testid="recovery-dni" placeholder="DNI" className={inp} value={dni} onChange={(e) => setDni(e.target.value)} />
            {!resetToken ? (
              <button data-testid="recovery-request" onClick={pedirToken} className="btn-gold w-full rounded-full px-8 py-3 text-xs uppercase tracking-[0.18em]">Generar código</button>
            ) : (
              <>
                <input data-testid="recovery-new-password" type="password" placeholder="Nueva contraseña" className={inp} value={newPw} onChange={(e) => setNewPw(e.target.value)} />
                <button data-testid="recovery-confirm" onClick={resetear} className="btn-gold w-full rounded-full px-8 py-3 text-xs uppercase tracking-[0.18em]">Guardar contraseña</button>
              </>
            )}
            <button onClick={() => setRecovery(false)} className="w-full text-xs text-[#8b7355] underline">Volver</button>
          </div>
        )}
        <Link to="/" className="mt-8 block text-center text-xs text-[#8b8480]">Volver al sitio</Link>
      </div>
    </div>
  );
}
